import {Pressable, Text, TextStyle, View, ViewStyle} from "react-native";
import CardImage from "@/lib/components/CardImage";
import {ReactNode} from "react";
import globstyles from "@/lib/globstyles";
import Editable from "@/lib/components/Editable";

type Props = {
    image_url: string | null | undefined,
    color: string,
    contrast_color: string,
    title: string,
    strikethrough?: boolean,
    children?: ReactNode,
    onPress?: () => any,
    onEditImage?: () => any,
    onEditTitle?: () => any,
}

export default function Card(props: Props) {
    const showImage = !!props.image_url || !!props.onEditImage;

    const headerRadius = showImage ? 0 : 16;
    const headerStyle: TextStyle = {
        backgroundColor: props.color,
        color: props.contrast_color,
        borderTopLeftRadius: headerRadius,
        borderTopRightRadius: headerRadius,
        textDecorationLine: props.strikethrough ? "line-through" : "none",
    };

    const footerStyle: ViewStyle = {
        borderColor: props.color,
    };

    const editableTitleStyle: ViewStyle = {
        backgroundColor: props.color,
        padding: 16,
        borderRadius: 0,
    };

    const editableTextStyle: TextStyle = {
        color: props.contrast_color,
        fontSize: 24,
        fontWeight: 600,
    }

    return (
        <Pressable style={globstyles.cardContainer}
                   onPress={props.onPress}
                   focusable={!!props.onPress}
                   disabled={!props.onPress}
        >
            {showImage &&
                <CardImage
                    onPressEdit={props.onEditImage}
                    editBackgroundColor={props.color}
                    editBorderColor={!!props.image_url ? props.color : props.contrast_color}
                    source={!!props.image_url ? props.image_url : undefined}
                />
            }
            {!!props.onEditTitle &&
                <View
                    style={editableTitleStyle}
                >
                    <Editable
                        color={props.contrast_color}
                        onPress={props.onEditTitle}
                    >
                        <Text style={editableTextStyle}>{props.title}</Text>
                    </Editable>
                </View>
            }
            {!props.onEditTitle &&
                <Text style={[globstyles.cardTitle, headerStyle]}>{props.title}</Text>
            }
            <View style={[globstyles.cardContents, footerStyle]}>
                {props.children}
            </View>
        </Pressable>
    )
}